// eslint-disable-next-line
export const numeric = (value: any) => Number(value)
